import { Injectable } from '@angular/core';
import { Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, UserRole } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Always allow magiclink route to bypass authentication
    // This includes both /magiclink and /magiclink?token=xxx
    if ('magiclink' === route.routeConfig?.path) {
      console.log('Magiclink route detected, bypassing auth check');
      return true;
    }
    
    const isLoggedIn = this.authService.isLoggedIn;
    
    if (true === isLoggedIn) {
      // Check if token is still valid
      this.authService.checkTokenExpiry();
      
      // Role-based redirection for dashboard routes
      if (state.url === '/' || state.url === '/dashboard') {
        const currentUser = this.authService.currentUserValue;
        if (currentUser && currentUser.role === UserRole.PLATFORM_OWNER) {
          console.log('God user accessing dashboard route, redirecting to God overview');
          return this.router.createUrlTree(['/god/overview']);
        }
      }
      
      return this.authService.isLoggedIn;
    }
    
    // If not logged in, try to validate token from URL (if present)
    this.authService.validateTokenFromUrl();
    
    // If not logged in, just return false and let the session monitor handle the login
    if (false === this.authService.isLoggedIn) {
      // Don't redirect to login page, let the session monitor handle it
      return false;
    }
    
    return true;
  }
}
